
import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  FormControl,
  Link,
  MenuItem,
  Select,
  Typography,
  Button,
  Tooltip,
  Checkbox,
  SelectChangeEvent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { Formik, Field, Form, FieldProps } from 'formik';
import arrowleft from '../../../src/assests/images/arrow-red.svg';
import pause from '../../../src/assests/images/pause.svg';
import trash from '../../../src/assests/images/trash.svg';
import * as Yup from 'yup';
import { getTeamById, editteamform, getteamlist, getmodules, pauseaccount, getmodulename, profiledata, updatemember, getteammaneid, approverejectediteamform } from './api';
import { decodeJWT, getToken } from '../../utils/utils';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { debounce } from 'lodash';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useAlert } from '../../pages/AlertContext/AlertContext';
import PauseAccountPopup from './PauseAccountPopup';
import Resume from '../../../src/assests/images/resume-account.svg';
import ConfirmPopup from './ConfirmPopup';
//import PauseAccountPopup from './PauseAccountPopup';
const LineArrow = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 5L8 11L14 5" stroke="#000" strokeWidth="2" />
  </svg>
);

interface TeamFormValues {
  firstName: string;
  lastName: string;
  team: string[];
  mobileNumber: string;
  emailId: string;
  moduleAccess: string[];
  moduleOwner: string;
  loginId: string;
  password: string;
  mainmodule_id: number[];
}

interface Module {
  id: number;
  module_name: string;
}

interface Team {
  id: number;
  team_name: string;
}

interface TeammembersProps {
  checked?: boolean; // Optional to match ProtectedRoute
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
  data?: string[];
  setData?: React.Dispatch<React.SetStateAction<string[]>>;
}



const EditTeamForm: React.FC<TeammembersProps> = ({ checked, setChecked, data }) => {
  const { showAlert } = useAlert();
  const token = getToken();

  const decodedToken = decodeJWT(token);
  console.log(decodedToken, "decodedTokendecodedTokendecodedToken", token, "tokentokentokentoken")
  const userRole = decodedToken?.user_role_name || "guest";
  const roleNames: string[] = decodedToken?.roleNames || [];

  const ememem = decodedToken?.email
  const isis = decodedToken?.id





  const stableRoleNames = useMemo(() => roleNames, [roleNames.join(",")]);

  useEffect(() => {
    console.log("checked changed:", checked);
  }, [checked]);
  const [derivedRole, setDerivedRole] = useState("");

  useEffect(() => {
    if (checked && roleNames.includes("Admin") && roleNames.includes("Module Owner")) {
      setDerivedRole("Admin");
    } else if (!checked && roleNames.includes("Admin") && roleNames.includes("Module Owner")) {
      setDerivedRole("Module Owner");
    } else if (userRole === "Admin") {
      setDerivedRole("Admin");
    } else if (userRole === "Module Owner") {
      setDerivedRole("Module Owner");
    } else {
      setDerivedRole("");
    }
  }, [checked]);


  const { id: urlId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  console.log(queryParams, "queryParamsssssssssssss")
  const source = queryParams.get('source')?.trim();
  console.log(source, "sourcesourcesource")
  const sources = queryParams.get('source');

  // Get only the first part before '/'
  const trimmedSource = sources ? sources.split('/')[0] : null;
  console.log(trimmedSource, "trimmedSourcetrimmedSource")
  const [statusss, setstatusss] = useState(false);
  const [statusss33, setstatusss33] = useState(false);
  const [statusss22, setstatusss22] = useState(false);

  useEffect(() => {
    const fullUrl = window.location.href;
    console.log("Full URL:ssssss", fullUrl);
    if (fullUrl.includes("source=messenger")) {
      setstatusss22(true);
    }
    // Example: Check if URL contains "status"
    if (fullUrl.includes("status")) {
      setstatusss(true);
    }
    if (fullUrl.includes("messenger")) {
      setstatusss33(true);
    }
  }, []);
  console.log(statusss, "statusss4444444444444")
  const [initialValues, setInitialValues] = useState<TeamFormValues>({
    firstName: '',
    lastName: '',
    team: [],
    mobileNumber: '',
    emailId: '',
    moduleAccess: [],
    moduleOwner: '',
    loginId: '',
    password: '',
    mainmodule_id: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [team, setTeam] = useState<Team[]>([]);
  const [modules, setModules] = useState<Module[]>([]);
  const [moduledefault, setModuledefault] = useState('');

  const [moduledefault66, setModuledefault66] = useState('');
  const [expirename, setexpirename] = useState('');
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [moduledefault22, setModuledefault22] = useState<string[]>([]);
  const [reqdesc, setReqdesc] = useState<string>('');
  const [tempid, setTempid] = useState<string>(''); // Renamed for consistency
  const [openDialog, setOpenDialog] = useState(false);
  const [editableFields, setEditableFields] = useState<string[]>([]);
  const [moduleOwnerEmail, setModuleOwnerEmail] = useState<string | null>(null);
  const [memberId, setMemberId] = useState<string | null>(null); // Store profiledata id
  const [statusdata, setstatusdata] = useState(false);
  const [mainidd, setmainidd] = useState('');
  const [mainteamid, setmainteamid] = useState('');

  const [openPausePopup, setOpenPausePopup] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const handleCloseConfirm = () => {
    setConfirmOpen(false);
  };

  const handleConfirmSubmit = () => {
    // perform form submit action here
    console.log('Form submitted!');
    setConfirmOpen(false);
  };




  useEffect(() => {
    // const fetchModules = async () => {
    //   try {
    //     const res = await getmodules(token);
    //     setModules(res?.data?.data || []);
    //   } catch (error) {
    //     console.error('Failed to fetch modules:', error);
    //     setModules([]);
    //   }
    // };


    const fetchTeamData = async () => {
      try {
        const res = await getteamlist(token);
        setTeam(res?.data?.data || []);
      } catch (error) {
        console.error('Error fetching team data:', error);
      }
    };

    fetchTeamData();
  }, [token]);









  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        if (trimmedSource === 'messenger') {
          const res = await profiledata({ id: urlId || '' }, token);
          const data = res.data.data[0];
          setMemberId(String(data.id)); // Store profiledata id
          setmainteamid(data.tmp_id)
          setTempid(data.tmp_id || ''); // Store tmp_id
          setReqdesc(data.req_desc || '');
          setModuledefault66(data.roles || '');
          if (data.record_status === "paused") {
            setIsPaused(true)
          }
          setModuledefault(data.module_owner_data[0]?.first_name || '');
          setModuledefault22(data.module_id || []);
          setModuleOwnerEmail(data.module_owner_data[0]?.module_owner_email || null);
          const initialFirstName = data.req_desc?.toLowerCase().includes('ameet') ? 'Ameet' : data.first_name || '';
          setInitialValues({
            firstName: initialFirstName,
            lastName: data.last_name || '',
            team: data.team_id || [],
            mobileNumber: data.phone || '',
            emailId: data.company_email_id || '',
            moduleAccess: data.module_id || [],
            moduleOwner: data.finalmoduleownernames || '',
            loginId: data.email || '',
            password: data.login_password || '',
            mainmodule_id: data.module_id.map(Number) || [],
          });
          const editable = parseReqdesc(data.req_desc || '');
          setEditableFields(editable);
          setOpenDialog(!!data.req_desc);
        } else {
          if (!urlId) {
            showAlert('Team Member ID is required.', 'error');
            return;
          }
          const res = await getTeamById(urlId, token);
          const data = res.data.data;
          console.log(data, "ssssssssssss44445555555555")
          setmainidd(data.id)

          setMemberId(urlId); // Use URL id for non-messenger

          setModuledefault(data.module_owner || '');
          setexpirename(data.expire_desc)
          if (data.record_status === "paused") {
            setIsPaused(true)
          }
          setModuledefault66(data.roles || '');

          setModuledefault22(Array.isArray(data.module_id) ? data.module_id : []);
          setInitialValues({
            firstName: data.first_name || '',
            lastName: data.last_name || '',
            team: Array.isArray(data.team_id)
              ? data.team_id.map(String)
              : data.team_id
                ? [String(data.team_id)]
                : [],
            mobileNumber: data.mobile_num?.toString() || '',
            emailId: data.company_email_id || '',
            moduleAccess: Array.isArray(data.module_id) ? data.module_id : [],
            moduleOwner: data.module_owner || '',
            loginId: data.login_id || '',
            password: data.login_password || '',
            mainmodule_id: data.module_id.map(Number) || [],
          });
          setEditableFields(['firstName', 'lastName', 'mobileNumber', 'emailId', 'team', 'moduleAccess', 'moduleOwner', 'loginId', 'password']);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        showAlert('Failed to fetch team member data.', 'error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [urlId, token, source]);

  // ...existing code...
  const matchesAny = (desc: string, variants: string[]) =>
    variants.some(v => desc.includes(v));

  const parseReqdesc = (reqdesc: string): string[] => {
    if (!reqdesc) return [];
    const lowerReqdesc = reqdesc.toLowerCase();
    const fields: string[] = [];

    // First Name variants
    if (
      matchesAny(lowerReqdesc, [
        'first name',
        'first_name',
        'firstname',
        'firstname',
        'firstName',
        'ameet',
        'amit'
      ])
    ) {
      fields.push('firstName');
    }

    // Last Name variants
    if (
      matchesAny(lowerReqdesc, [
        'last name',
        'last_name',
        'lastname',
        'lastName'
      ])
    ) {
      fields.push('lastName');
    }

    // Email variants
    if (
      matchesAny(lowerReqdesc, [
        'email',
        'email_id',
        'emailid',
        'email id',
        'company_email_id'
      ])
    ) {
      fields.push('emailId', 'loginId');
    }

    // Mobile/Phone variants
    if (
      matchesAny(lowerReqdesc, [
        'phone',
        'mobile',
        'mobile_number',
        'mobile number',
        'phone_number',
        'phone number'
      ])
    ) {
      fields.push('mobileNumber');
    }

    // Team variants
    if (
      matchesAny(lowerReqdesc, [
        'team',
        'team_id',
        'teamid'
      ])
    ) {
      fields.push('team');
    }

    // Module variants
    if (
      matchesAny(lowerReqdesc, [
        'module',
        'module_access',
        'moduleaccess',
        'module owner',
        'module_owner'
      ])
    ) {
      fields.push('moduleAccess', 'moduleOwner');
    }

    // Password variants
    if (
      matchesAny(lowerReqdesc, [
        'password',
        'login_password',
        'login password'
      ])
    ) {
      fields.push('password');
    }

    return Array.from(new Set(fields));
  };
  // ...existing code...
  //   useEffect(() => {
  //   const fetchModules = async () => {
  //     try {
  //       const res = await getmodules(urlId || '', ememem, moduledefault66 !== '' ? moduledefault66 : '', token); // ememem = email
  //       setModules(res?.data?.data || []);
  //     } catch (error) {
  //       console.error('Failed to fetch modules:', error);
  //       setModules([]); // fallback in case of error
  //     }
  //   };

  //   if (ememem && moduledefault66 && token) {
  //     fetchModules(); // only fetch if both values are present
  //   }
  // }, [ememem,moduledefault66, token]); 


  useEffect(() => {
    const fetchModules = async () => {
      try {
        const res = await getmodules(isis, ememem, derivedRole, token);
        setModules(res?.data?.data || []);
      } catch (error) {
        console.error('Failed to fetch modules:', error);
        setModules([]);
      }
    };

    if (ememem && token) {
      fetchModules();
    }
  }, [isis, ememem, derivedRole, token]);

  const validationSchema = Yup.object({
    firstName: editableFields.includes('firstName') ? Yup.string().required('First Name is required') : Yup.string(),
    lastName: editableFields.includes('lastName') ? Yup.string().required('Last Name is required') : Yup.string(),
    //   team: editableFields.includes('team')
    // ? Yup.string().required('Team is required')
    // : Yup.string(),
    mobileNumber: editableFields.includes('mobileNumber') ? Yup.string().required('Mobile Number is required') : Yup.string(),
    emailId: editableFields.includes('emailId') ? Yup.string().email('Invalid email').required('Email is required') : Yup.string(),
    moduleAccess: editableFields.includes('moduleAccess') ? Yup.array().min(1, 'At least one module is required') : Yup.array(),
    moduleOwner: editableFields.includes('moduleOwner') ? Yup.string().required('Module Owner is required') : Yup.string(),
    // loginId: editableFields.includes('loginId') ? Yup.string().required('Login ID is required') : Yup.string(),
    // password: editableFields.includes('password') ? Yup.string().required('Password is required') : Yup.string(),
  });

  const handleSubmit = async (values: TeamFormValues) => {
    setIsSubmitting(true);

    try {
      console.log(values, "valuesvaluesvaluesvaluesvalues")
      if (trimmedSource === 'messenger') {
        if (!tempid) {
          showAlert('Temporary ID is required for profile update.', 'error');
          return;
        }
        const reqBody = {
          first_name: values.firstName,
          last_name: values.lastName,
          email: values.loginId,
          phone: values.mobileNumber,
          company_email_id: values.emailId,
          team_name: values.team.join(',') || '',
          module_name: values.moduleAccess.join(',') || '',
          module_owner: values.moduleOwner || '',
          module_owner_email: moduleOwnerEmail,
        };



        const response = await updatemember(tempid, token, reqBody); // Use tempid
        if (response.data.success) {
          showAlert('Profile updated successfully!', 'success');
          navigate('/team-Members');
          setTimeout(() => window.location.reload(), 100);
        } else {
          showAlert(response.data.message || 'Failed to update profile.', 'error');
        }
      } else {
        if (!memberId) {
          showAlert('Team Member ID is required.', 'error');
          return;
        }
        const reqBody = {
          first_name: values.firstName,
          last_name: values.lastName,
          mobile_num: values.mobileNumber,
          company_email_id: values.emailId,
          team_id: Array.isArray(values.team) ? values.team.join(',') : String(values.team),
          module_id: values.moduleAccess.join(','),
          login_password: values.password,
          mainmodule_id: values.mainmodule_id,
        };
        console.log(reqBody, "reqBodyreqBodyreqBodyreqBody")

        const response = await editteamform(memberId, reqBody, token);
        console.log(response, "responseeeeeeeeeeeeeeeeee")

        if (response.data.success) {
          showAlert('Team Member successfully updated!', 'success');
          navigate('/team-Members');
          setTimeout(() => window.location.reload(), 100);
        } else {
          showAlert(response.data.message || 'Failed to update teahhhhhm member.', 'error');
        }
      }
    } catch (error: any) {
      console.error('Failed to update:', error);
      showAlert(error.response?.data?.message || 'An error occurred while updating.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleResumeAccount = async () => {
    // Your resume logic here
    console.log("Account Resumed");
    setIsPaused(false);

    if (!memberId) {
      showAlert('ID is required to resume the account.', 'error');
      return;
    }

    try {
      const response = await pauseaccount(memberId, { status: 'active' }, token); // Assuming 'resumeaccount' is the correct function to resume the account
      if (response?.data) {
        showAlert('Account resumed successfully!', 'success');
        setOpenPausePopup(false); // Close the pause popup if resuming
      } else {
        showAlert('Failed to resume account.', 'error');
      }
    } catch (error) {
      console.error('Resume error:', error);
      showAlert('An error occurred while resuming the account.', 'error');
    }
  };


  const handlePauseAccount = async () => {
    setIsPaused(true);
    if (!memberId) {
      showAlert('ID is required to pause the account.', 'error');
      return;
    }
    try {
      const response = await pauseaccount(memberId, { status: 'paused' }, token);
      if (response?.data) {
        showAlert('Account paused successfully!', 'success');
        setOpenPausePopup(true);
      } else {
        showAlert('Failed to pause account.', 'error');
        setOpenPausePopup(false);
      }
    } catch (error) {
      console.error('Pause error:', error);
      showAlert('An error occurred while pausing the account.', 'error');
    }
  };
  const handleClosePopup = () => {
    setOpenPausePopup(false); // close popup
  };

  console.log(isPaused, "isPaused")
  const handleDeleteAccount = async () => {
    if (!memberId) {
      showAlert('No ID provided for deletion.', 'error');
      return;
    }
    try {
      const response = await pauseaccount(memberId, { status: 'inactive' }, token);
      if (response?.data) {
        showAlert('Account deleted successfully!', 'success');
      } else {
        showAlert('Failed to delete account.', 'error');
      }
    } catch (error) {
      console.error('Delete error:', error);
      showAlert('An error occurred while deleting the account.', 'error');
    }
  };

  const handleModuleChange = debounce(async (selected: string[], form: any) => {
    try {
      const res = await getmodulename(selected.map(Number), token);
      const moduleOwner = res?.data?.data?.datas?.module_owner_name;
      if (moduleOwner) {
        form.setFieldValue('moduleOwner', moduleOwner);
        form.setFieldValue(
          'mainmodule_id',
          res?.data?.data?.datas.module_id?.split(',').map((id: string) => Number(id)) || []
        );
      }
    } catch (err) {
      console.error('Error fetching module name:', err);
      form.setFieldValue('moduleOwner', '');
    }
  }, 300);

  const handleChange = async () => {
    try {
      const res = await getteammaneid(Number(mainidd), token);
      const moduleOwner = res?.data?.data?.datas?.module_owner_name;
      console.log('Module Owner:', moduleOwner);
    } catch (err) {
      console.error('Error fetching module name:', err);
    }

    console.log('Button clicked');
  };
  const handleApprove = async (is_approved: string) => {
    try {
      const yy = await approverejectediteamform(Number(mainteamid), is_approved, token)

    } catch (error) {
      console.error('Error during approval:', error);
    }
  };
  console.log(isPaused, "isPausedisPausedssssssssssss")
  console.log(moduledefault, "moduledefaultmoduledefaultmoduledefault")
  console.log(derivedRole, "moduledefault66sssssssssss")
  return (
    <Box>
      <Box sx={{ backgroundColor: '#F9FBFC', padding: '32px 32px 0' }}>
        <Box sx={{ borderBottom: '1px solid #dfdfdf', paddingBottom: '20px' }}>
          <Box
            sx={{
              textDecoration: "none",
              fontSize: 14,
              fontWeight: 600,
              color: "rgba(142, 2, 15, 1)",
              display: "flex",
            }}
          >
            <Typography sx={{ color: "#696A6B", marginRight: "10px" }}>
              <Link
                href="/team-Members" sx={{ color: "#696A6B", textDecoration: "none", fontSize: 14, }}> Team Member </Link>/
            </Typography>
            Edit Profile
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              variant="h3"
              sx={{ fontSize: 24, fontWeight: 600, color: '#000', marginTop: '16px' }}
            >
              Edit Profile
            </Typography>
            <Box>
              {!isPaused ? (
                <Tooltip title="Pause Account">
                  <Link
                    href="#"
                    sx={{ marginRight: "20px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      handlePauseAccount();
                    }}
                  >
                    <img src={pause} alt="Pause" />
                  </Link>
                </Tooltip>
              ) : (
                <Tooltip title="Resume Account">
                  <Link
                    href="#"
                    sx={{ marginRight: "20px", position: "relative", top: "-4px", marginTop: "-10px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      handleResumeAccount();

                    }}
                  >
                    <img src={Resume} alt="Resume" />
                  </Link>
                </Tooltip>
              )}
              {/* <PauseAccountPopup open={openPausePopup} handleClose={handleClosePopup} /> */}
              {/* <Tooltip title="Delete">
                <Link href="#" onClick={(e) => { e.preventDefault(); handleDeleteAccount(); }}>
                  <img src={trash} alt="Delete" />
                </Link>
              </Tooltip> */}
            </Box>
          </Box>
        </Box>
        {(statusss33 === true || expirename === 'Expiring in 30 days') && (
          <Box>
            <Box
              sx={{
                backgroundColor: '#FFF7E6',
                padding: 2,
                borderRadius: '8px',
                display: 'flex',
                gap: 1.5,
                alignItems: 'flex-start',
                color: '#3C3C3C',
              }}
            >
              <InfoOutlinedIcon fontSize="small" sx={{ marginTop: '3px', color: '#5c5c5c' }} />
              <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Box>
                  {statusss33 === true ? (
                    <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 0.5, color: '#7D7E7F' }}>
                      Edit request
                    </Typography>
                  ) : (

                    <Typography variant="body2" sx={{ fontWeight: 500, marginBottom: 0.5, color: '#7D7E7F' }}>
                      Role is Expiring
                    </Typography>
                  )}

                  <Typography variant="body2" sx={{ color: '#494A4B' }}>
                    {reqdesc || `This role is ${expirename}`}
                  </Typography>
                </Box>
                <Box>
                  {statusss33 === false && (
                    <Button
                      sx={{
                        fontSize: '14px',
                        fontWeight: '500',
                        padding: '20px 30px',
                        borderRadius: '10px',
                        marginTop: '0px',
                        border: '1px solid #C8172F',
                        color: '#C8172F',
                        textDecoration: 'none',
                        display: 'block',
                      }}
                      variant="outlined"
                      onClick={handleChange}
                    >
                      Renew the Role
                    </Button>
                  )}

                </Box>
              </Box>
            </Box>
          </Box>
        )}
        <Box sx={{ marginTop: '30px' }}>
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '500',
              color: '#8C8C8C',
              marginBottom: '8px',
              textTransform: 'uppercase',
            }}
          >
            INFORMATION
          </Typography>
        </Box>

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, handleBlur, touched, errors, isValid, dirty, setFieldValue }) => (
            <Form>
              <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap', maxWidth: '800px', width: '100%' }}>
                <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                  <Typography
                    component="label"
                    sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                  >
                    First Name*
                  </Typography>
                  <Field name="firstName">
                    {({ field, meta }: FieldProps) => {
                      const isDisabled =
                        trimmedSource === 'messenger' && !isPaused
                          ? !editableFields.includes('firstName')
                          : isPaused;
                      return (
                        <>
                          <input
                            {...field}
                            placeholder="First Name"
                            aria-label="First Name"
                            aria-describedby={meta.touched && meta.error ? 'firstName-error' : undefined}
                            disabled={isDisabled}
                            style={{
                              width: '100%',
                              borderRadius: '10px',
                              height: '52px',
                              border: '1px solid #E7E8E9',
                              padding: '14px 12px',
                              color: '#7D7E7F',
                              fontSize: '16px',
                              fontWeight: '500',
                              backgroundColor: isDisabled ? '#f5f5f5' : '#fff',
                            }}
                          />
                          {meta.touched && meta.error && (
                            <div
                              id="firstName-error"
                              style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                            >
                              {meta.error}
                            </div>
                          )}
                        </>
                      );
                    }}
                  </Field>
                </FormControl>


                <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                  <Typography
                    component="label"
                    sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                  >
                    Last Name*
                  </Typography>
                  <Field name="lastName">
                    {({ field, meta }: FieldProps) => {

                      const isDisabled =
                        trimmedSource === 'messenger' && !isPaused
                          ? !editableFields.includes('lastName')
                          : isPaused;
                      return (
                        <>
                          <input
                            {...field}
                            placeholder="Last Name"
                            aria-label="Last Name"
                            aria-describedby={meta.touched && meta.error ? 'lastName-error' : undefined}
                            disabled={isDisabled}
                            style={{
                              width: '100%',
                              borderRadius: '10px',
                              height: '52px',
                              border: '1px solid #E7E8E9',
                              padding: '14px 12px',
                              color: '#7D7E7F',
                              fontSize: '16px',
                              fontWeight: '500',
                              backgroundColor: isDisabled ? '#f5f5f5' : '#fff',
                            }}
                          />
                          {meta.touched && meta.error && (
                            <div
                              id="lastName-error"
                              style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                            >
                              {meta.error}
                            </div>
                          )}
                        </>
                      );
                    }}
                  </Field>

                </FormControl>

                <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                  <Typography
                    component="label"
                    sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                  >
                    Mobile Number*
                  </Typography>
                  <Field name="mobileNumber">
                    {({ field, meta }: FieldProps) => {
                      // const isDisabled =  !editableFields.includes('mobileNumber') 
                      const isDisabled =
                        trimmedSource === 'messenger' && !isPaused
                          ? !editableFields.includes('mobileNumber')
                          : isPaused;
                      return (
                        <>
                          <input
                            {...field}
                            placeholder="eg. 7666782990"
                            aria-label="Mobile Number"
                            aria-describedby={meta.touched && meta.error ? 'mobileNumber-error' : undefined}
                            disabled={isDisabled}
                            style={{
                              width: '100%',
                              borderRadius: '10px',
                              height: '52px',
                              border: '1px solid #E7E8E9',
                              padding: '14px 12px',
                              color: '#7D7E7F',
                              fontSize: '16px',
                              fontWeight: '500',
                              backgroundColor: isDisabled ? '#f5f5f5' : '#fff',
                            }}
                          />
                          {meta.touched && meta.error && (
                            <div
                              id="mobileNumber-error"
                              style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                            >
                              {meta.error}
                            </div>
                          )}
                        </>
                      );
                    }}
                  </Field>

                </FormControl>

                <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                  <Typography
                    component="label"
                    sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                  >
                    Company Email ID*
                  </Typography>
                  <Field name="emailId">
                    {({ field, meta }: FieldProps) => {
                      // const isDisabled = !editableFields.includes('emailId')
                      const isDisabled =
                        trimmedSource === 'messenger' && !isPaused
                          ? !editableFields.includes('emailId')
                          : isPaused;
                      return (
                        <>
                          <input
                            {...field}
                            placeholder="eg. john.doe@company.com"
                            aria-label="Company Email ID"
                            aria-describedby={meta.touched && meta.error ? 'emailId-error' : undefined}
                            disabled={isDisabled}
                            style={{
                              width: '100%',
                              borderRadius: '10px',
                              height: '52px',
                              border: '1px solid #E7E8E9',
                              padding: '14px 12px',
                              color: '#7D7E7F',
                              fontSize: '16px',
                              fontWeight: '500',
                              backgroundColor: isDisabled ? '#f5f5f5' : '#fff',
                            }}
                          />
                          {meta.touched && meta.error && (
                            <div
                              id="emailId-error"
                              style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                            >
                              {meta.error}
                            </div>
                          )}
                        </>
                      );
                    }}
                  </Field>

                </FormControl>

                <FormControl sx={{ width: { xs: "100%", sm: "352px" } }}>
                  <Typography
                    component="label"
                    sx={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#282829",
                      marginBottom: "8px",
                    }}
                  >
                    Team*
                  </Typography>
                  <Field name="team">
                    {(props: FieldProps) => {
                      const { field, form, meta } = props;
                      // const isDisabled = !editableFields.includes("team")


                      const isDisabled =
                        trimmedSource === 'messenger' && !isPaused
                          ? !editableFields.includes('team')
                          : isPaused;
                      const isMulti = true; // Set to true for multi-select, false for single-select
                      return (
                        <>
                          <Select
                            multiple={isMulti}
                            value={
                              isMulti
                                ? Array.isArray(field.value)
                                  ? field.value
                                  : []
                                : field.value || ""
                            }
                            onChange={(event) => {
                              form.setFieldValue(field.name, event.target.value);
                            }}
                            displayEmpty
                            id="team"
                            inputProps={{ "aria-label": "Select Team" }}
                            disabled={isDisabled}
                            IconComponent={LineArrow}
                            renderValue={(selected) => {
                              if (!selected || (Array.isArray(selected) && selected.length === 0)) {
                                return (
                                  <em style={{ color: "#A0A0A0" }}>Select Team Access</em>
                                );
                              }
                              if (isMulti) {
                                const selectedTeams = team.filter((mod) =>
                                  selected.includes(String(mod.id))
                                );
                                return selectedTeams.map((mod) => mod.team_name).join(", ");
                              }
                              const selectedTeam = team.find(
                                (mod) => String(mod.id) === String(selected)
                              );
                              return selectedTeam ? selectedTeam.team_name : "";
                            }}
                            sx={{
                              width: "100%",
                              borderRadius: "12px",
                              backgroundColor: isDisabled ? "#f5f5f5" : "#fff",
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#000",
                              height: "52px",
                              "& .MuiSelect-select": {
                                padding: "14px 12px",
                                display: "block",
                                alignItems: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "& svg": {
                                top: "calc(45% - 4px)",
                                right: "12px",
                                position: "absolute",
                                pointerEvents: "none",
                              },
                            }}
                          >
                            {team.map((mod) => (
                              <MenuItem key={mod.id} value={String(mod.id)}>
                                {isMulti && (
                                  <Checkbox
                                    checked={
                                      Array.isArray(field.value) &&
                                      field.value.includes(String(mod.id))
                                    }
                                  />
                                )}
                                {mod.team_name}
                              </MenuItem>
                            ))}
                          </Select>
                          {meta.touched && meta.error && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "14px",
                                fontWeight: "400",
                                marginTop: "4px",
                              }}
                            >
                              {meta.error}
                            </div>
                          )}
                        </>
                      );
                    }}
                  </Field>
                </FormControl>



                <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                  <Typography
                    component="label"
                    sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                  >
                    Module Access*
                  </Typography>
                  <Field name="moduleAccess">
                    {({ field, form, meta }: FieldProps) => {
                      // const isDisabled = !editableFields.includes("moduleAccess") 

                      const isDisabled =
                        trimmedSource === 'messenger' && !isPaused
                          ? !editableFields.includes('moduleAccess')
                          : isPaused;

                      return (
                        <>
                          <Select
                            multiple
                            value={Array.isArray(field.value) ? field.value : []}
                            onChange={async (event: SelectChangeEvent<string[]>) => {
                              const selected = (event.target.value as string[]).map(String);
                              form.setFieldValue('moduleAccess', selected);
                              await handleModuleChange(selected, form);
                            }}
                            displayEmpty
                            id="dash"
                            inputProps={{ 'aria-label': 'Select Module' }}
                            IconComponent={LineArrow}
                            disabled={isDisabled}
                            renderValue={(selected: string[]) => {
                              if (!selected || selected.length === 0) {
                                return <em style={{ color: '#A0A0A0' }}>Select Module Access</em>;
                              }
                              const selectedArray = selected.map(String);
                              const selectedNames = modules
                                .filter((mod) => selectedArray.includes(String(mod.id)))
                                .map((mod) => mod.module_name);
                              return selectedNames.join(', ');
                            }}
                            sx={{
                              width: '100%',
                              borderRadius: '12px',
                              backgroundColor: isDisabled ? "#f5f5f5" : "#fff",
                              fontSize: '16px',
                              fontWeight: '500',
                              color: '#000',
                              height: '52px',
                              '& .MuiSelect-select': {
                                padding: '14px 12px',
                                alignItems: 'center',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              "&:hover .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#E7E8E9",
                              },
                              '& svg': {
                                top: 'calc(45% - 4px)',
                                right: '12px',
                                position: 'absolute',
                                pointerEvents: 'none',
                              },
                            }}
                          >
                            {modules.map((mod) => (
                              <MenuItem key={mod.id} value={mod.id}>
                                <Checkbox
                                  checked={Array.isArray(field.value) && field.value.map(String).includes(String(mod.id))}
                                  onChange={async (e) => {
                                    const isChecked = e.target.checked;
                                    const modIdStr = String(mod.id);
                                    const currentValue = (field.value || []).map(String);
                                    let newValue: string[];
                                    if (isChecked) {
                                      newValue = Array.from(new Set([...currentValue, modIdStr]));
                                    } else {
                                      newValue = currentValue.filter((val: any) => val !== modIdStr);
                                    }
                                    form.setFieldValue('moduleAccess', newValue);
                                    await handleModuleChange(newValue, form);
                                  }}
                                />
                                {mod.module_name}
                              </MenuItem>
                            ))}
                          </Select>
                          {meta.touched && meta.error && (
                            <div style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}>
                              {meta.error}
                            </div>
                          )}
                        </>
                      );
                    }}
                  </Field>

                </FormControl>

                <Field type="hidden" name="mainmodule_id" />

                {/* <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                  <Typography
                    component="label"
                    sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                  >
                    Module Owner*
                  </Typography>
                  <Field name="moduleOwner">
                    {({ field, meta }: FieldProps) => (
                      <>
                        <input
                          {...field}
                          value={field.value || moduledefault}
                          placeholder="Module owner*"
                          aria-label="Module Owner"
                          aria-describedby={meta.touched && meta.error ? 'moduleOwner-error' : undefined}
                          disabled={!editableFields.includes('moduleOwner')}
                          style={{
                            width: '100%',
                            borderRadius: '10px',
                            height: '52px',
                            border: '1px solid #E7E8E9',
                            padding: '14px 12px',
                            color: '#7D7E7F',
                            fontSize: '16px',
                            fontWeight: '500',
                            backgroundColor: !editableFields.includes('moduleOwner') ? '#f5f5f5' : '#fff',
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            id="moduleOwner-error"
                            style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                          >
                            {meta.error}
                          </div>
                        )}
                      </>
                    )}
                  </Field>
                </FormControl> */}
                <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                  <Typography
                    component="label"
                    sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                  >
                    Module Owner*
                  </Typography>
                  <Field name="moduleOwner">
                    {({ field, meta }: FieldProps) => (
                      <>
                        <input
                          {...field}
                          value={field.value || moduledefault}
                          placeholder="Module owner*"
                          aria-label="Module Owner"
                          aria-describedby={meta.touched && meta.error ? 'moduleOwner-error' : undefined}
                          disabled={!!field.value || !!moduledefault || !editableFields.includes('moduleOwner')}
                          style={{
                            width: '100%',
                            borderRadius: '10px',
                            height: '52px',
                            border: '1px solid #E7E8E9',
                            padding: '14px 12px',
                            color: '#7D7E7F',
                            fontSize: '16px',
                            fontWeight: '500',
                            backgroundColor:
                              !!field.value || !!moduledefault || !editableFields.includes('moduleOwner')
                                ? '#f5f5f5'
                                : '#fff',
                          }}
                        />
                        {meta.touched && meta.error && (
                          <div
                            id="moduleOwner-error"
                            style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                          >
                            {meta.error}
                          </div>
                        )}
                      </>
                    )}
                  </Field>
                </FormControl>


                <Typography
                  sx={{
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#8C8C8C',
                    marginTop: '32px',
                    marginBottom: '16px',
                    textTransform: 'uppercase',
                    width: '100%',
                  }}
                >
                  Login & Password
                </Typography>

                <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap', maxWidth: '800px', width: '100%' }}>
                  <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                    <Typography
                      component="label"
                      sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                    >
                      Provide Login ID*
                    </Typography>
                    <Field name="loginId">
                      {({ field, meta, form }: FieldProps) => (
                        <>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              border: '1px solid #E7E8E9',
                              borderRadius: '10px',
                              height: '52px',
                              width: '100%',
                              paddingLeft: '12px',
                              paddingRight: '12px',

                              backgroundColor: '#f5f5f5',
                            }}
                          >
                            <input
                              {...field}
                              placeholder="Provide Login ID"
                              aria-label="Login ID"
                              aria-describedby={meta.touched && meta.error ? 'loginId-error' : undefined}
                              readOnly
                              // disabled={!editableFields.includes('loginId')}
                              style={{
                                border: 'none',
                                outline: 'none',
                                flexGrow: 1,
                                color: '#7D7E7F',
                                fontSize: '16px',
                                fontWeight: '500',
                                backgroundColor: 'transparent',
                              }}
                            />
                            {editableFields.includes('loginId') && (
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 500,
                                  color: '#C8102E',
                                  whiteSpace: 'nowrap',
                                  cursor: 'pointer',
                                }}
                                onClick={() => form.setFieldValue('loginId', values.emailId)}
                              >
                                Set as company email
                              </Typography>
                            )}
                          </Box>
                          {meta.touched && meta.error && (
                            <div
                              id="loginId-error"
                              style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                            >
                              {meta.error}
                            </div>
                          )}
                        </>
                      )}
                    </Field>
                  </FormControl>

                  <FormControl sx={{ width: { xs: '100%', sm: '352px' } }}>
                    <Typography
                      component="label"
                      sx={{ fontSize: '16px', fontWeight: '500', color: '#282829', marginBottom: '8px' }}
                    >
                      Provide Password*
                    </Typography>
                    <Field name="password">
                      {({ field, meta }: FieldProps) => (
                        <>
                          <input
                            {...field}
                            type="password"
                            placeholder="Provide Password"
                            aria-label="Password"
                            aria-describedby={meta.touched && meta.error ? 'password-error' : undefined}
                            readOnly={true}
                            // readOnly={trimmedSource === 'messenger'}
                            // disabled={!editableFields.includes('password')}
                            style={{
                              width: '100%',
                              borderRadius: '10px',
                              height: '52px',
                              border: '1px solid #E7E8E9',
                              padding: '14px 12px',
                              color: '#7D7E7F',
                              fontSize: '16px',
                              fontWeight: '500',
                              // backgroundColor: trimmedSource === 'messenger' ? '#f5f5f5' : '#fff',
                              backgroundColor: '#f5f5f5'
                            }}
                          />
                          {meta.touched && meta.error && (
                            <div
                              id="password-error"
                              style={{ color: 'red', fontSize: '14px', fontWeight: '400', marginTop: '4px' }}
                            >
                              {meta.error}
                            </div>
                          )}
                        </>
                      )}
                    </Field>
                  </FormControl>
                </Box>

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#FFF8E1',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    marginTop: '24px',
                    width: 'fit-content',
                    maxWidth: '100%',
                    marginBottom: "20px"
                  }}
                >
                  <Box
                    component="span"
                    sx={{
                      width: 20,
                      height: 20,
                      borderRadius: '50%',
                      backgroundColor: '#FFC107',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 14,
                      fontWeight: '600',
                      marginRight: '12px',

                    }}
                  >
                    i
                  </Box>
                  <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#4A4A4A', }}>
                    Note: Clicking “Submit” will trigger an approval email to the Module Owner
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ width: '105%', marginLeft: "-32px", borderTop: '1px solid #cfcfcf', background: "#fff", marginTop: '10px', marginBottom: '10px' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Button
                    sx={{
                      fontSize: '14px',
                      fontWeight: '500',
                      color: '#C8172F',
                      textTransform: 'capitalize',
                      padding: '0',
                      marginLeft: "50px"
                    }}
                    onClick={() => navigate('/team-Members')}
                  >
                    <img style={{ marginRight: '8px' }} src={arrowleft} alt="arrowleft" />
                    Back
                  </Button>
                  <Box>
                    {statusss === true && (
                      <>
                        <Button
                          type="submit"
                          // disabled={!(isValid && dirty)}
                          style={{
                            marginTop: "20px",
                            backgroundColor: "#C8102E",
                            color: "#fff",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            fontWeight: "600",
                            marginRight: "10px",
                            // cursor: isValid && dirty ? "pointer" : "not-allowed",
                          }}
                          onClick={() => handleApprove("rejected")}
                        >
                          Reject
                        </Button>

                        <Button
                          type="submit"
                          // disabled={!(isValid && dirty)}
                          style={{
                            marginTop: "20px",
                            backgroundColor: "#C8102E",
                            color: "#fff",
                            border: "none",
                            padding: "10px 20px",
                            borderRadius: "8px",
                            fontWeight: "600",
                            marginRight: "10px",
                            // cursor: isValid && dirty ? "pointer" : "not-allowed",
                          }}
                          onClick={() => handleApprove("approved")}
                        >
                          Approval
                        </Button>
                      </>
                    )}


                    {statusss === false && (
                      <>
                        <Button
                          type="button" // Important: NOT "submit"
                          onClick={() => setConfirmOpen(true)} // Open confirmation
                          disabled={!(isValid && dirty) || isSubmitting}
                          sx={{
                            marginTop: '20px',
                            backgroundColor: isValid && dirty && !isSubmitting ? '#C8102E' : '#ccc',
                            color: '#fff',
                            border: 'none',
                            padding: '10px 20px',
                            borderRadius: '8px',
                            fontWeight: '600',
                            marginRight: "50px",
                            cursor: isValid && dirty && !isSubmitting ? 'pointer' : 'not-allowed',
                            '&:hover': {
                              backgroundColor: isValid && dirty && !isSubmitting ? '#A8102E' : '#ccc',
                            },
                          }}
                        >
                          {isSubmitting ? 'Submitting...' : 'Submit'}
                        </Button>

                        <ConfirmPopup
                          handleYes={() => handleSubmit(values)} // Manual call after confirm
                          statusdata={statusdata}
                          setstatusdata={setstatusdata}
                          open={confirmOpen}
                          onClose={handleCloseConfirm}
                          onConfirm={handleConfirmSubmit}
                          editteammemver={Number(moduledefault66)}
                          moduleOwner={trimmedSource === 'messenger' ? values.firstName : values.firstName} chekmodulw={0} />
                      </>
                    )}


                  </Box>

                </Box>

              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default EditTeamForm;